import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("tamashii_token", data.token);
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center px-5">
      <div className="grain" />
      <div className="w-full max-w-md">
        <p className="overline text-center mb-4">Atelier Access</p>
        <h1 className="font-serif text-6xl text-bone text-center leading-none mb-12">TAMASHii</h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="overline block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="w-full bg-transparent border border-line px-4 py-3 text-bone focus:border-crimson outline-none font-mono text-sm"
              placeholder="admin@tamashii.in"
              required
            />
          </div>
          <div>
            <label className="overline block mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="w-full bg-transparent border border-line px-4 py-3 text-bone focus:border-crimson outline-none font-mono text-sm"
              placeholder="••••••••"
              required
            />
          </div>
          {error && <p className="text-crimson font-mono text-xs" data-testid="admin-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-button" className="btn-fill w-full py-4 flex items-center justify-center gap-3 overline text-sm disabled:opacity-50">
            {loading ? "Entering…" : "Enter Atelier"} <ArrowRight size={16} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
